// Shared pure-utility methods that were duplicated (byte-identical) across many
// views/components. Registered globally in main.js via app.mixin so every component
// can use them without per-file wiring.
//
// Behavior-preserving by construction:
//  - each member here is byte-identical to the local copies it replaces, and
//  - a component's OWN method always overrides a global-mixin method, so any file
//    that kept a different variant of the same method is unaffected.
import dateUtils from '@/plugins/date-utils';
import moment from 'moment';
export default {
  methods: {
    convertDateToString(date, seperator = "/") {
      return dateUtils.getStringWithTimeFromDate(
        moment(date).toDate(),
        seperator
      );
    },
    convertDateToString2(date, seperator = "-") {
      return dateUtils.getStringFromDatePickFormatDatePick2(
        moment(date).toDate(),
        seperator
      );
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!
      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      this.today = dd + "/" + mm + "/" + yyyy;
    },
    isNumber: function (evt) {
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46 &&
        charCode !== 45
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isNumberpositive: function (evt) {
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    numericKey: function (evt) {
      let expect = evt.target.value.toString() + evt.key.toString();
      if (!/^\d*(?:\.\d*)?$/.test(expect) || Number.parseFloat(expect) <= 0) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isTwoDecimalPlaces(number) {
      const regex = /^\d+(\.\d{1,2})?$/;
      return regex.test(number.toString());
    },
    substring(text) {
      if (text != null) {
        if (text.length > 50) {
          return text.substring(0, 50) + "...";
        }
        return text;
      }
      return text;
    },
    PhoneNumberValidation(phno) {
      let phoneno = /^\d{10}$/;
      return phoneno.test(phno) || "Invalid Phone format";
    },
    formatDate(dateInput) {
      if (!dateInput) {
        return "";
      }
      if (
        typeof dateInput === "string" &&
        /^\d{4}-\d{2}-\d{2}$/.test(dateInput)
      ) {
        return dateInput;
      }
      const d = new Date(dateInput);
      if (Number.isNaN(d.getTime())) {
        return dateInput.toString().substr(0, 10);
      }
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const date = `${year}-${month}-${day}`;
      return date;
    },
    // Display-only formatter: converts the stored `YYYY-MM-DD` wire value into
    // `DD-MM-YYYY` for showing in a readonly picker field. Pure string transform
    // (no Date object) so it never shifts the day across timezones. The underlying
    // model / API payload stays `YYYY-MM-DD` — only the displayed text changes.
    formatDateDisplay(dateInput) {
      if (!dateInput) {
        return "";
      }
      const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateInput.toString());
      if (!m) {
        return dateInput.toString();
      }
      return `${m[3]}-${m[2]}-${m[1]}`;
    },
    getFormattedHeaderDate(year, month, selectedDate) {
      let date;

      if (selectedDate) {
        const selected = new Date(selectedDate);
        if (selected.getFullYear() === year && selected.getMonth() === month) {
          date = selected;
        } else {
          date = new Date(year, month, new Date().getDate());
        }
      } else {
        const today = new Date();
        if (today.getFullYear() === year && today.getMonth() === month) {
          date = today;
        } else {
          date = new Date(year, month, 1);
        }
      }

      const options = { weekday: 'short', month: 'short', day: 'numeric' };
      return date.toLocaleDateString('en-US', options);
    },
  },
};
